export default {
    character: 'Character',
    characters: 'Characters',
    remaining: 'Remaining',
    optional: '(optional)',
    required: '(required)',
};
